import { twMerge } from 'tailwind-merge';
import { useToaster } from './useToaster';

export type ToasterProps = {
    open?: boolean;
    helper?: string; // evaluate to delete
    action?: void; // evaluate to delete
    handleClose?: () => void;
    label: string;
    variant?: ToasterBackground;
    className?: string;
    autoClose?: boolean;
    dataTestId?: string;
    timeClose?: number;
};

export type ToasterBackground = 'success' | 'error' | 'info';

const toasterBackground = {
    success: 'bg-[#49B574] rounded-lg',
    error: 'bg-[#FF333F] rounded-lg',
    info: 'bg-variant-800 hover:bg-variant-500 active:bg-variant-900 disabled:bg-variant-100 border-2 border-variant-800 hover:border-variant-100 active:border-variant-900 disabled:border-variant-100 text-white',
};

export function Toaster(props: ToasterProps) {
    const { open, close } = useToaster({
        open: props.open,
        autoClose: props.autoClose,
        timeClose: props.timeClose,
        onClose: props.handleClose,
    });
    const classes = twMerge(toasterBackground[props.variant || 'success']);

    return (
        <div className={twMerge('fixed bottom-4 right-20 min-w-[20%] z-30', props.className)}>
            {open && (
                <div className={`flex items-center p-4 w-full min-w-xs max-w-md text-white ${classes}`}>
                    <h2
                        data-test-id={props.dataTestId ?? `toaster-${props.variant}`}
                        data-testid={props.dataTestId ?? `toaster-${props.variant}`}
                        className="text-sm font-semibold"
                    >
                        {props.label}
                    </h2>
                    <div className="flex items-center ml-auto space-x-2">
                        {props.helper && (
                            <button
                                className="text-sm font-medium text-blue-600 p-1.5 hover:bg-blue-100 rounded-lg dark:text-blue-500 dark:hover:bg-gray-700"
                                onClick={() => props.action}
                            >
                                {props.helper}
                            </button>
                        )}
                        <button type="button" className={classes} aria-label="Close" onClick={close}>
                            <svg
                                aria-hidden="true"
                                className="w-5 h-5"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                    clipRule="evenodd"
                                ></path>
                            </svg>
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Toaster;
